@let v = initialValue();
<fo-side-panel
  [title]="v?.name ?? ''"
  [closeAriaLabel]="'close' | i18nextCap"
  (closed)="inputs.onCancel()"
>
  <fo-kebab-menu panel-actions [items]="menuItems" />
  @if (v != null) {
    <fo-equipment-form
      [showSectionIndex]="false"
      [assetTypeChoices]="(assetTypes$ | async) ?? []"
      [companyChoices$]="companies$"
      [locationChoices$]="locations$"
      [parentChoices$]="parents$"
      [categoryChoices$]="categories$"
      [showCompany]="true"
      [editableCompany]="canAssignCompany()"
      [showActive]="true"
      [disabled]="!editable"
      [initialValue]="v"
      (valueChange)="onValueChange($event)"
      (newAttachmentsChange)="attachments.update($event)"
      [attachments]="attachments.displayedAttachments"
    />
  }
  @if (editable && v != null) {
    <div class="footer" panel-footer>
      <button
        mat-flat-button
        color="primary"
        type="button"
        [disabled]="!form?.valid"
        (click)="onSave()"
      >
        {{ 'save' | i18nextCap }}
      </button>
    </div>
  }
</fo-side-panel>
